import React from "react";
import { useSelector } from "react-redux";
import { Backdrop, CircularProgress, Stack, Typography } from "@mui/material";

const Spinner =()=> {
  const { open, message } = useSelector((s) => s.spinner);
  return (
    <Backdrop open={open} sx={{ color: "#fff", zIndex: (t) => t.zIndex.modal + 2 }}>

      <Stack alignItems="center" spacing={2}>
        <Typography variant="body2">{message}</Typography>
        <CircularProgress />
      </Stack>
    </Backdrop>
  );
}

export default Spinner;
